import React from 'react';
import { Col, Row } from 'react-bootstrap';
import useIsMobile from 'utils/hooks/useIsMobile';
import CurrentPanel from '../CurrentPanel';
import PreviewPanel from '../PreviewPanel';
import './index.scss';

export default function RegularStatusPrediction({ area }: { area: string }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="status-regular-mobile">
        <CurrentPanel area={area} />
        <PreviewPanel area={area} />
      </div>
    );
  }

  return (
    <Row className="flex-fill p-5 h-100">
      <Col xl={6}>
        <CurrentPanel area={area} />
      </Col>
      <Col xl={6} className="mt-3 mt-xl-0">
        <PreviewPanel area={area} />
      </Col>
    </Row>
  );
}
